
const DATETIME_PATT = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(:(\d{2}))?Z?$/;
const DATE_PATT = /^(\d{4})-(\d{2})-(\d{2})Z?$/;

const DateUtil = {
	/**
	 * Parse JSON ISO 8601 datetime to JS Date
	 */
	parseDate(val) {
		const result = {};
		if (val == null) result.date = null;
		else if (DATETIME_PATT.test(val)) {
			const hasZ = val.charAt(val.length-1) === 'Z';
			let millis = Date.parse(hasZ ? val : val.concat('Z'));
			let d = new Date(millis);
			if (!hasZ) {
				d = new Date(d.getTime() + (d.getTimezoneOffset()*60000));
			}
			result.date = d;
			result.wholeDay = false;
		} else if (DATE_PATT.test(val)) {
			const hasZ = val.charAt(val.length-1) === 'Z';
			let millis = Date.parse(hasZ ? val.substring(0, val.length-1) : val);
			let d = new Date(millis);
			if (!hasZ) {
				// This was local date(time)
				d = new Date(d.getTime() + (d.getTimezoneOffset()*60000));
			}
			result.date = d;
			result.wholeDay = true;
		} else result.date = null;
		return result;
	},

	/**
	 * Format JS Date object to JSON ISO 8601 format (without Z suffix)
	 */
	formatDate(date, withTime) {
		if (date === null) return null;
		const year = date.getFullYear().toString();
		let month = (date.getMonth()+1).toString();
		let day = date.getDate().toString();
		if (month.length === 1) month = '0'+month;
		if (day.length === 1) day = '0'+day;
		let json = year + '-' + month + '-' + day;
		if (withTime) {
			let hours = date.getHours().toString();
			let minutes = date.getMinutes().toString();
			let seconds = date.getSeconds().toString();
			if (hours.length === 1) hours = '0'+hours;
			if (minutes.length === 1) minutes = '0'+minutes;
			if (seconds.length === 1) seconds = '0'+seconds;
			json = json + 'T' + hours + ':' + minutes + ':' + seconds;
		}
		return json;
	}
};

window.DateUtil = DateUtil;	// Expose as global

export default DateUtil;